import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppointmentComponent } from './appointment/appointment.component';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { AnAppointmentCommonModule } from '@autonation/dt-an-components-lib/an-appointment';
import { ReactiveFormsModule } from '@angular/forms';

const routes: Routes = [
  {
    path: '', component: AppointmentComponent
  }
];

@NgModule({
  declarations: [
    AppointmentComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    AnAppointmentCommonModule,
    RouterModule.forChild(routes),
    ReactiveFormsModule
  ]
})
export class AppointmentModule { }
